import { FormFieldsDisabledProvider } from '@/components/form/context/formFieldsDisabled.provider';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

export interface HouseholdPermissionAwareDisabledProviderProps {
  children: React.ReactNode;
  forceDisabled?: boolean;
}

/**
 * Provider that automatically disables all form fields when the current user is in view-only mode.
 *
 * This component wraps FormFieldsDisabledProvider and automatically sets isDisabled based on
 * the user's view-only status determined by their authorization level and the view_only_permission_support feature flag.
 *
 * @param children React children to render
 * @param forceDisabled Optional prop to force disable forms regardless of view-only status (useful for loading states)
 */
export const HouseholdPermissionAwareDisabledProvider = ({
  children,
  forceDisabled = false,
}: HouseholdPermissionAwareDisabledProviderProps) => {
  const canEditHouseholdData = useCanEditHouseholdData();

  return (
    <FormFieldsDisabledProvider
      isDisabled={forceDisabled || !canEditHouseholdData}
    >
      {children}
    </FormFieldsDisabledProvider>
  );
};
